import { render } from "./high_risk_sites.vue?vue&type=template&id=1cdbdf6f"
import script from "./high_risk_sites.vue?vue&type=script&lang=js"
export * from "./high_risk_sites.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__